import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { ScrollableTabs, Text, ToastContext } from '@reveni-io/reveni-ui'

import QueryFilter from '@/common/components/QueryFilter/QueryFilter'
import { userPermissions } from '@/common/constants'
import AppContext from '@/common/context/app.context'
import useUserPermissions from '@/common/hooks/useUserPermissions/useUserPermissions'

import ExceptionsContent from './ExceptionsContent/ExceptionsContent'
import useExceptions from './hooks/useExceptions/useExceptions'
import { exceptionsStatus } from './constants'
import * as Styles from './styles'

const ExceptionsList = () => {
  const { t } = useTranslation()
  const { info } = useContext(AppContext)
  const {
    exceptions,
    totalPages,
    policyRules,
    gettingPolicyRules,
    refetchData,
    currentPage,
    setCurrentPage,
    loading,
    deleteException,
    deletingException,
    toggleException,
    togglingException,
    statusTab,
    setStatusTab,
    setSearch,
  } = useExceptions(info?.selectedStore?.id)
  const navigate = useNavigate()
  const { setToastInfo } = useContext(ToastContext)
  const { hasPermission } = useUserPermissions()

  const navigateToCreateNewException = () => {
    navigate('/config/return-policy/allow-list/new')
  }

  const handleDelete = async exception => {
    try {
      await deleteException({ storeId: info.selectedStore.id, exceptionId: exception.id })
      setToastInfo({ show: true, message: t('Eliminado correctamente'), type: 'success' })
      refetchData()
    } catch (error) {
      setToastInfo({ show: true, message: error.errorMessage, type: 'error' })
    }
  }

  const onToggle = async (exception, checked) => {
    try {
      await toggleException({
        storeId: info.selectedStore.id,
        exceptionId: exception.id,
        value: checked ? 'enable' : 'disable',
      })
      setToastInfo({ show: true, message: t('Modificado correctamente'), type: 'success' })
      refetchData()
    } catch (error) {
      setToastInfo({ show: true, message: error.errorMessage, type: 'error' })
    }
  }

  const handleEdit = exception => {
    navigate(`/config/return-policy/allow-list/${exception.id}`, {
      state: { childPageTitle: exception.order_number, selectedException: exception },
    })
  }

  const handleTabChange = value => {
    setStatusTab(value)
    setCurrentPage(1)
  }

  return (
    <Styles.MainContainer>
      <Text type="titleM">{t('Lista de excepciones')}</Text>
      <Text type="bodyMRegular">
        {t('Añade excepciones para que tus clientes puedan devolver productos de pedidos no elegibles.')}
      </Text>
      <QueryFilter onChange={setSearch} placeholder={t('Núm. de pedido')} />
      <div>
        <ScrollableTabs
          value={statusTab}
          tabs={[
            { label: t('Activas'), value: exceptionsStatus.active },
            { label: t('Archivadas'), value: exceptionsStatus.archived },
          ]}
          onChange={handleTabChange}
        />
        <ExceptionsContent
          loading={loading || deletingException || togglingException || gettingPolicyRules}
          exceptions={exceptions}
          totalPages={totalPages}
          policyRules={policyRules}
          currentPage={currentPage}
          onChangePage={setCurrentPage}
          onEdit={handleEdit}
          onDelete={handleDelete}
          onToggle={onToggle}
          onCreateNew={navigateToCreateNewException}
          hasEditPermission={hasPermission(userPermissions.editAllowedList)}
        />
      </div>
    </Styles.MainContainer>
  )
}

export default ExceptionsList
